import React from 'react';
import { SelectDealerships } from './Steps/Dealerships/SelectDealerships';
import { CONSTANTS } from './constants'
import { SelectDMSAccounts } from './Steps/DMSAccounts/SelectDMSAccounts';
import { PrivacyProtection } from './Steps/PrivacyProtection/PrivacyProtection';
import { ManageApiFields } from './Steps/ApiFieldsSelection/ManageApiFields';
import { ReviewTerms } from './Steps/Review Terms/ReviewTerms';
import { ApiSubscriptionSettings } from './Steps/ApiSubscriptionSettings/ApiSubscriptionSettings';

export const contentMapper = stepList => {
    const numberToContentMap = {};
    stepList?.forEach((name, index) => {
      index++;  //to map from 1 instead of 0
      switch(name) {
        case CONSTANTS.SELECT_LOCATIONS:
          numberToContentMap[index] = () => <SelectDealerships />;
          break;
        case CONSTANTS.REVIEW_TERMS:
          numberToContentMap[index] = () =>   <ReviewTerms data-testid="mi-step-2" />;
          break;
        case CONSTANTS.API_SUBSCRIPTION_SETTINGS:
          numberToContentMap[index] = () => <ApiSubscriptionSettings />;
          break;
        case CONSTANTS.DMS_ACCOUNTS:
            numberToContentMap[index] = () => <SelectDMSAccounts />;
            break;
        case CONSTANTS.PRIVACY_PROTECTION:
            numberToContentMap[index] = () => <PrivacyProtection />;
            break;
        case CONSTANTS.API_FIELDS:
            numberToContentMap[index] = () => <ManageApiFields />;
            break;
        default:
            break;
      };
    });
    return numberToContentMap;
};